import clsx from 'clsx';
import { STEP_COMPLETION } from '../../uploadJourneyUtils';
import greenTick from '../../../../../assets/green-tick.svg';
import styles from './UploadTabs.module.scss';
import { Mixpanel } from '../../../../../utils/mixpanel';
import { COMPANY_OPEN_TAB } from '../../../../../utils/constants/mixpanelEvents/companyEvents';
import { useSearchParams } from 'react-router-dom';
interface UploadTabsProps {
    selectedStep: string;
    setSelectedStep: Function;
    uploadTabs: any;
    isInvestor: boolean;
    uploadJourneyData: any;
}

function UploadTabs({ selectedStep, setSelectedStep, uploadTabs, isInvestor, uploadJourneyData }: UploadTabsProps) {
    const [searchParams] = useSearchParams();
    const isStepComplete = (step) => {
        return STEP_COMPLETION?.[step]?.isComplete(uploadJourneyData);
    };
    const selectedTab = searchParams.get('selectedTab');

    return (
        <div style={isInvestor ? { padding: '0' } : {}} className={styles.UploadTabs}>
            {uploadTabs
                ?.filter((tab) => (selectedTab === 'creditBureau' ? tab.id === 'creditBureau' : true))
                ?.map((tab, index) => (
                    <div
                        className={clsx(styles.SingleTab, {
                            [styles.SelectedTab]: uploadTabs?.length > 1 && selectedStep === tab.id,
                        })}
                        key={tab.id}
                        onClick={() => {
                            Mixpanel.track(COMPANY_OPEN_TAB, {
                                TabName: tab.id,
                            });
                            setSelectedStep(tab.id);
                        }}
                    >
                        <div
                            className={clsx(styles.StepButton, {
                                [styles.SelectedStepButton]: selectedStep === tab.id,
                                // D7 (borrower only): active wins over complete for the background (N3) —
                                // the tick still shows next to the label either way. The investor branch
                                // is untouched: Complete applies whenever the step is complete, same as today.
                                [styles.Complete]: isInvestor ? isStepComplete(tab.id) : isStepComplete(tab.id) && selectedStep !== tab.id,
                            })}
                        >
                            {/* Investor branch is untouched: it never showed a number or a tick (today's
                                behaviour). Borrower (!isInvestor): D7 removes the leading number and
                                moves the tick to AFTER the label instead. */}
                            <div className={styles.StepLabel}>{tab.label === 'creditBureau' ? 'Credit Bureau' : tab.label}</div>
                            {!isInvestor && isStepComplete(tab.id) && (
                                <img className={styles.TickImgAfterLabel} src={greenTick} alt="grn" />
                            )}
                        </div>
                    </div>
                ))}
        </div>
    );
}

export default UploadTabs;
